import { CSSObject } from '@emotion/core';

import { scale } from '@scripts/gds';

import { filterTitleStyles, scrollbarStyles } from '../../../../../../styles';

export const getCheckboxesContainerStyles = (isExpanded: boolean): CSSObject => ({
    paddingRight: '3px',
    ...(isExpanded && {
        maxHeight: '312px',
        overflowY: 'auto',
        ...scrollbarStyles.narrow,
    }),
});

export const checkboxesGridStyles: CSSObject = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: `${scale(1)}px ${scale(1)}px`,
};

export const getCheckboxStyles = (isDisabled: boolean): CSSObject => ({
    minHeight: '24px',
    display: 'flex',
    alignItems: 'left',
    ...(isDisabled && { opacity: 0.6 }),
    '& input:disabled + label': {
        cursor: 'default !important',
    },
    '& label': {
        minHeight: '24px',
        display: 'flex',
        alignItems: 'left',
        paddingLeft: '36px',
    },
    '& label::before': {
        top: 0,
        left: 0,
        width: '24px',
        height: '24px',
    },
    '& label svg': {
        top: '12px',
        left: '12px',
    },
});

export const booleanFilterContainerStyles: CSSObject = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '24px',
    width: '100%',
};

export const accordionButtonStyles: CSSObject = {
    ...filterTitleStyles,
    display: 'inline-flex',
    alignItems: 'center',
    gap: scale(1),
    width: 'auto',
    padding: 0,
    '& > svg': {
        position: 'static',
        transform: 'none',
        transition: 'transform ease 300ms, fill ease 300ms',
    },
    '&[aria-expanded="true"] > svg': {
        transform: 'rotate(-180deg)',
    },
};
